/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const CreateClusterLogicalBackup = {
  id: 'cluster-logical-backup.post',
  tag: 'Cluster',
  summary: 'Create cluster logical backup',
  description: 'Create a cluster logical backup',
  method: 'post',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/backup/logical`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
